import {Component, OnDestroy, OnInit} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {ActivatedRoute, Router} from '@angular/router';
import {Guid} from 'guid-typescript';
import {DeleteQueryAction} from '@shared/store/actions/query.actions';
import {Configuration} from '@shared/models/configuration';
import {CreateWorkflowAction} from '../../../../workflow/store/workflow.actions';
import {getWorkflowReducerState, isWorkflowCleanedUp} from '../../../../workflow/store/workflow.selector';
import {takeUntil} from 'rxjs/operators';
import {Observable, Subject} from 'rxjs';
import {IWorkflowState} from '../../../../workflow/store/workflow.reducer';

@Component({
    standalone: false,
    selector: 'particle-participants-for-filling-report',
  templateUrl: './participants-for-filling-report.component.html',
  styleUrls: ['./participants-for-filling-report.component.scss']
})
export class ParticipantsForFillingReportComponent implements OnInit, OnDestroy {
  workflowId: string;
  apiEndpointKey = 'DataSurveyApi';
  private workflowState$: Observable<IWorkflowState>;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  private cleanedUp$: Observable<string>;
  private reportId: string;
  private ItemId: string;
  private reportTaskId: string;

  constructor(private queryStore: Store<IQueryState>,
              protected activatedRoute: ActivatedRoute,
              private router: Router) {
    this.workflowId = Guid.create().toString();
  }

  ngOnInit() {
    this.reportTaskId = Guid.create().toString();
    this.activatedRoute.params.pipe(takeUntil(this.ngUnsubscribe)).subscribe((params: any) => {
      this.reportId = params.reportId;
      this.ItemId = params.itemId;
    });
    this.loadWorkflow();
  }
  loadWorkflow() {

    const url = `${Configuration.getConfig(this.apiEndpointKey)}Command/CreateWorkflow`;
    const action = new CreateWorkflowAction(url, this.workflowId, 'Participants For Filling Report', 'participants-for-filling-report-workflow', false);
    action.setParameters({
      'ReportId': this.reportId,
      'ItemId': this.ItemId,
      'ReportTaskId': this.reportTaskId
    });
    this.queryStore.dispatch(action);
    this.workflowState$ = this.queryStore.pipe(select(getWorkflowReducerState, this.workflowId));
    this.workflowState$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
      console.log(state);
    });
    this.cleanedUp$ = this.queryStore.pipe(select(isWorkflowCleanedUp, this.workflowId));
    this.cleanedUp$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
      if (state === 'Cancelled') {
        this.router.navigateByUrl(`/dac6-reporter/filing/monthly`);
      }
      else if(state === 'Finished') {
        this.router.navigateByUrl(`/dac6-reporter/reports/` + this.reportId);
      }
    });
  }

  onGridCellValueChange($event) {

  }

  ngOnDestroy() {

  }
}
